<script setup lang="ts">
import { Icon } from '@dabble/quillui';

defineProps<{
  checked: boolean;
}>();
</script>

<template>
  <Icon
    :name="checked ? 'checkmark-circle' : 'circle'"
    :class="['app-check-indicator', { 'app-check-indicator--checked': checked }]"
    size="medium"
    aria-hidden="true"
  />
</template>

<style scoped>
.app-check-indicator {
  display: inline-flex;
  flex-shrink: 0;
}

.app-check-indicator--checked {
  color: var(--color-fg-success);
}
</style>
